export const sanitizePhoneInput = (value: string) => {
  return value.replace(/\D/g, '');
};

export const US_PHONE_PLACEHOLDER = '+1 000 000 0000';
export const US_FORMATTED_PHONE_NUMBER_LENGTH = 17;

export const formatUSPhoneForDisplay = (value: string) => {
  const countryCallingCode = value.slice(0, 1);
  const rest = value.slice(1);

  if (!value.length) {
    return '';
  }

  if (value.length === 1) {
    return `+${countryCallingCode}`;
  }

  if (value.length <= 4) {
    return `+${countryCallingCode} (${rest}`;
  }

  if (value.length <= 7) {
    return `+${countryCallingCode} (${rest.slice(0, 3)}) ${rest.slice(3, 6)}`;
  }

  return `+${countryCallingCode} (${rest.slice(0, 3)}) ${rest.slice(3, 6)}-${rest.slice(6)}`;
};
